import { ReactTFC } from "../../../utils/fp/missing-ts-parts";

import { SerializedStyles } from "@emotion/react";
import { css } from "@emotion/react";

import React from "react";
import { SwarovskiLink } from "../../_shared-components/ui-elements/SwarovskiLink";
import { DealerLocatorIcons } from "../icons/dealer-locator-icons";
import { CSS_COLORS } from "../../../styles/styles-css-variables";

export const DealerCardBottomInfo: ReactTFC<{
  internationalPhoneNumber: string | null | undefined;
  email: string | null | undefined;
  navigationLink: string;
  website?: {
    link: string;
    label: string;
  };
}> = props => {
  return (
    <div
      className={props.website ? "with-website" : "no-website"}
      css={css`
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        align-self: stretch;

        margin-top: 12px;

        &.no-website {
          justify-content: flex-end;
        }
      `}
    >
      {props.website && (
        <SwarovskiLink isInternal={true} scrollToTop={true} link={props.website.link} styled={"underline-plain"}>
          {props.website.label}
        </SwarovskiLink>
      )}

      <div
        css={css`
          display: grid;

          grid-column-gap: 20px;
          grid-template-columns: repeat(3, 45px);
          grid-template-rows: 45px;
        `}
      >
        {props.internationalPhoneNumber ? (
          <a href={`tel:${props.internationalPhoneNumber}`}>
            <DealerLocatorIcons icon={"PhoneIconSvg"} css={iconStyles} />
          </a>
        ) : (
          <DealerLocatorIcons icon={"PhoneIconSvg"} css={iconStyles} className={"disabled"} />
        )}
        {props.email ? (
          <a href={`mailto:${props.email}`}>
            <DealerLocatorIcons icon={"MailIconSvg"} css={iconStyles} />
          </a>
        ) : (
          <DealerLocatorIcons icon={"MailIconSvg"} css={iconStyles} className={"disabled"} />
        )}
        {props.navigationLink ? (
          <a href={props.navigationLink} target={"_blank"} rel={"noopener noreferrer"}>
            <DealerLocatorIcons icon={"NavigateIconSvg"} css={iconStyles} />
          </a>
        ) : (
          <DealerLocatorIcons icon={"NavigateIconSvg"} css={iconStyles} className={"disabled"} />
        )}
      </div>
    </div>
  );
};

const iconStyles = css`
  width: 100%;
  height: 100%;

  color: ${CSS_COLORS.Green};

  &.disabled {
    color: ${CSS_COLORS.Grey};
    cursor: not-allowed;
  }
`;
